import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6173eb99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-arrow-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.1043 0.630453L16.7369 7.26305C17.1439 7.67006 17.1439 8.32995 16.7369 8.73696L10.1043 15.3696C9.69732 15.7766 9.03743 15.7766 8.63042 15.3696C8.22341 14.9626 8.22341 14.3027 8.63042 13.8957L13.4839 9.04222H1.99998C1.42438 9.04222 0.957764 8.57561 0.957764 8.00001C0.957764 7.42441 1.42438 6.9578 1.99998 6.9578H13.4839L8.63042 2.10436C8.22341 1.69735 8.22341 1.03746 8.63042 0.630453C9.03743 0.223443 9.69732 0.223443 10.1043 0.630453Z",
    fill: "#fff"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}